import { EndOfContractDenialOfContractRenewalDetails } from 'services/ApiService/Franfinance/FranfinanceApiClient';
import { Reducer } from 'store/configureStore';
import { ApiRequest } from 'store/sharedModels';

export const endOfContractDenialOfContractRenewalInitialState = {
    results: {} as { [id: string]: ApiRequest<EndOfContractDenialOfContractRenewalDetails> },
} as const;

type EndOfContractDenialOfContractRenewaltState = typeof endOfContractDenialOfContractRenewalInitialState;

export const EndOfContractDenialOfContractRenewalReducer: Reducer<EndOfContractDenialOfContractRenewaltState> = (state = endOfContractDenialOfContractRenewalInitialState, action) => {
    switch (action.type) {

        case '@CUSTOMER_REQUEST_DETAILS/END_OF_CONTRACT/DENIAL_OF_CONTRACT_RENEWAL/GET':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: true,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_REQUEST_DETAILS/END_OF_CONTRACT/DENIAL_OF_CONTRACT_RENEWAL/GET_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: false,
                    },
                },
            };
        case '@CUSTOMER_REQUEST_DETAILS/END_OF_CONTRACT/DENIAL_OF_CONTRACT_RENEWAL/GET_FAILURE':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_SERVICE_DETAILS_RESPONSE/INSTRUCTION/SUBMIT_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_SERVICE_DETAILS_RESPONSE/NON_COMPLIANCE/SUBMIT_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        default:
            return state;

    }
};